<template>
  <Aside
    class="niche-aside"
    :is-opened="isOpened"
    :variant="mainSectionComponent.variant"
    @close="cancel"
  >
    <template #title>
      <div class="niche-aside__title">
        {{ asideTitle }}
      </div>
    </template>
    <template #subtitle>
      {{ asideSubTitle }}
      <Button
        v-if="mode === 'edit-niche'"
        class="niche-aside__delete-btn"
        variant="primary"
        size="xs"
        icon-left="delete"
        @click="$emit('deleteNiche')"
      >
        Удалить нишу
      </Button>
    </template>
    <div>
      <component
        :is="infoSectionComponent.component"
        v-if="infoSectionComponent"
        :aside-data.sync="asideData"
        is-mobile
      />
      <component :is="mainSectionComponent.component" :aside-data.sync="asideData" :mode="mode" />
    </div>
    <template v-if="infoSectionComponent" #info-section>
      <component :is="infoSectionComponent.component" :aside-data.sync="asideData" />
    </template>
    <template #footer>
      <Button
        v-for="(footerButton, index) in footerButtons"
        :key="'footer-button-' + index"
        :variant="footerButton.variant"
        :size="footerButton.size"
        :disabled="footerButton.disabled"
        @click="footerButton.onClick"
      >
        {{ footerButton.text }}
      </Button>
    </template>
  </Aside>
</template>

<script>
import _ from 'lodash';
import { asideDataToFaculty, facultyToAsideData } from '@/store/faculties/admin/faculties/mappers';
import Aside from '@/components/UiKit/v2/Aside';
import Button from '@/components/UiKit/v2/Button';
import Niche from './Steps/Niche';
import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';
import Step3Main from './Steps/Step3/MainSection';
import Step3Info from './Steps/Step3/InfoSection';
import Step4Main from './Steps/Step4/MainSection';
import Step4Info from './Steps/Step4/InfoSection';
import IconDefaulSquares from '@/style/icons/card-thumbs/default-squares.svg';

export default {
  name: 'FacultyAsideRoot',
  components: {
    Aside,
    Button
  },
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    selectedNiche: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: [Object, Array],
      default: () => ({})
    },
    mode: {
      type: String,
      /**
       * String(add-faculty|edit-faculty|add-niche|edit-niche|add-faculty|edit-faculty)
       */
      default: 'edit-category',
      validator: function (value) {
        return [
          'add-faculty',
          'edit-faculty',
          'add-niche',
          'edit-niche',
          'add-coach',
          'edit-coach'
        ].includes(value);
      }
    }
  },
  data() {
    return {
      defaultAsideData: {},
      asideData: {
        isValid: false,
        stepData: {
          niche: {
            nicheNameIsDirty: false,
            nicheNameMaxLength: 60,
            niche: {
              name: '',
              facultiesQuantity: null,
              customIcon: '',
              customIconBlob: '',
              icon: IconDefaulSquares,
              background: '#f7f7fb',
              textColor: '#76767B',
              area: {
                id: 0,
                name: ''
              },
              parent: {
                id: 0,
                name: ''
              }
            },
            options: {
              areas: [],
              categories: []
            }
          },
          step1: {
            id: undefined,
            facultyNameIsDirty: false,
            memberCountIsDirty: false,
            tags: [],
            name: '',
            niche: {
              name: '',
              description: 'N Сборных',
              icon: IconDefaulSquares,
              background: '#F7F7FB'
            },
            group: {
              id: 0,
              name: ''
            },
            stream: {}
          },
          step2: {
            coachList: [],
            coachImageBlob: '',
            coachImageFileObject: undefined
          },
          step3: {
            youtubeVideoId: '',
            youtubeVideoUrl: '',
            content: ''
          },
          step4: {},
          options: {
            niches: [],
            groups: [],
            coaches: []
          }
        },
        step: 1,
        steps: []
      }
    };
  },
  computed: {
    asideTitle() {
      if (this.mode === 'add-niche') {
        return 'Создание ниши';
      } else if (this.mode === 'edit-niche') {
        return 'Редактирование ниши';
      } else if (this.mode === 'add-coach') {
        return 'Создание тренера';
      } else if (this.mode === 'edit-coach') {
        return 'Редактирование тренера';
      } else {
        return 'Создание сборной';
      }
    },
    asideSubTitle() {
      if (this.mode === 'add-niche') {
        return '';
      } else if (this.mode === 'edit-niche') {
        return '';
      } else {
        return `Шаг ${this.asideData.step} / ${this.stepTotalCount}`;
      }
    },
    stepTotalCount() {
      return this.asideData.steps.length;
    },
    footerButtons() {
      if (this.mode === 'add-niche') {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Отменить',
            onClick: this.cancel
          },
          {
            size: 's',
            text: 'Создать нишу',
            onClick: this.addNiche,
            disabled: !this.asideData.isValid
          }
        ];
      }
      if (this.mode === 'edit-niche') {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Отменить',
            onClick: this.cancel
          },
          {
            size: 's',
            text: 'Сохранить нишу',
            onClick: this.patchNiche,
            disabled: !this.asideData.isValid
          }
        ];
      } else if (this.asideData.step === 1) {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Отменить',
            onClick: this.cancel
          },
          {
            size: 's',
            text: 'Следующий шаг',
            onClick: this.nextStep,
            disabled: !this.asideData.isValid
          }
        ];
      }
      if (this.asideData.step === 2) {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Шаг назад',
            onClick: this.previousStep
          },
          {
            size: 's',
            text: 'Следующий шаг',
            onClick: this.nextStep,
            disabled: !this.asideData.isValid
          }
        ];
      }
      if (this.asideData.step === 3) {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Шаг назад',
            onClick: this.previousStep
          },
          {
            size: 's',
            text: 'Предпросмотр',
            onClick: this.nextStep,
            disabled: !this.asideData.isValid
          }
        ];
      }
      if (this.asideData.step === 4) {
        return [
          {
            variant: 'primary',
            size: 's',
            text: 'Шаг назад',
            onClick: this.previousStep
          },
          {
            size: 's',
            text: this.mode === 'edit-faculty' ? 'Изменить сборную' : 'Добавить сборную',
            onClick: this.mode === 'edit-faculty' ? this.editFaculty : this.addFaculty,
            disabled: !this.asideData.isValid
          }
        ];
      } else {
        return [];
      }
    },
    currentSectionComponent() {
      return this.asideData.steps[this.asideData.step - 1];
    },
    mainSectionComponent() {
      if (this.currentSectionComponent.components) {
        return this.currentSectionComponent.components.find(item => item.section === 'main');
      } else {
        return this.currentSectionComponent;
      }
    },
    infoSectionComponent() {
      if (this.currentSectionComponent.components) {
        return this.currentSectionComponent.components.find(item => item.section === 'info');
      } else {
        return null;
      }
    }
  },
  watch: {
    selectedNiche(value) {
      this.asideData.stepData.niche.niche = {
        ...this.asideData.stepData.niche.niche,
        ...value,
        area: this.options.areas.find(a => a.id === value.area?.id) ?? {
          id: 0,
          name: ''
        }
      };
    },
    options(value) {
      if (this.mode.includes('faculty')) {
        this.asideData.stepData.options = value;
      }
    },
    value(newValue) {
      if (this.mode === 'edit-faculty') {
        if (newValue?.id) {
          this.asideData.stepData = {
            ...this.asideData.stepData,
            ...facultyToAsideData(newValue, this.options)
          };
          this.resetSteps();
        } else {
          this.resetAsideData();
        }
      }
    }
  },
  created() {
    this.setSteps();
    this.defaultAsideData = _.cloneDeep(this.asideData);
  },
  methods: {
    resetAsideData() {
      this.resetSteps();
      this.asideData = _.cloneDeep(this.defaultAsideData);
      if (this.mode.includes('niche')) {
        this.asideData.stepData.niche.options = this.options;
      } else {
        this.asideData.stepData.options = this.options;
      }
    },
    setSteps() {
      if (this.mode.includes('niche')) {
        this.asideData.steps = [
          {
            component: Niche,
            variant: 'normal'
          }
        ];
      } else {
        this.asideData.steps = [
          {
            component: Step1,
            variant: 'normal'
          },
          {
            component: Step2,
            variant: 'normal'
          },
          {
            components: [
              {
                component: Step3Main,
                variant: 'wide',
                section: 'main'
              },
              {
                component: Step3Info,
                variant: 'wide',
                section: 'info'
              }
            ]
          },
          {
            components: [
              {
                component: Step4Main,
                variant: 'wide',
                section: 'main'
              },
              {
                component: Step4Info,
                variant: 'wide',
                section: 'info'
              }
            ]
          }
        ];
      }
    },
    cancel() {
      this.$emit('close');
    },
    async patchNiche() {
      await this.$store.dispatch(
        'faculties/admin/niches/patchNiche',
        this.asideData.stepData.niche
      );
      this.$emit('close');
    },
    async addNiche() {
      await this.$store.dispatch('faculties/admin/niches/addNiche', this.asideData.stepData.niche);
      this.$emit('close');
    },
    previousStep() {
      if (this.asideData.step > 1) {
        this.asideData.isValid = false;
        this.asideData.step--;
      }
    },
    nextStep() {
      if (this.asideData.step < this.stepTotalCount) {
        this.asideData.isValid = false;
        this.asideData.step++;
      }
    },
    resetSteps() {
      this.asideData.step = 1;
    },
    addFaculty() {
      this.$emit('add', asideDataToFaculty(this.asideData.stepData));
    },
    editFaculty() {
      this.$emit('edit', asideDataToFaculty(this.asideData.stepData));
    },
    changeAsideData(data) {
      this.asideData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.niche-aside {
  &__delete-btn.ui-kit-v2-button {
    color: #36383e;
    padding: 0;
    font-weight: normal;
    background-color: transparent;
    border: none;

    &::v-deep {
      svg {
        margin-right: 8px;
      }

      svg path {
        fill: #898989 !important;
      }
    }

    &:hover::v-deep {
      svg path {
        fill: $ui-red !important;
      }
    }
  }

  &::v-deep .step {
    &__section {
      &:not(:first-of-type) {
        margin-top: 32px;
      }
    }

    &__title {
      margin-bottom: 16px;
      color: $ui-black-dark;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      display: flex;
    }

    &__description {
      color: $ui-gray-less-contrast;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 16px;
    }

    .input__wrapper,
    .selector {
      margin-bottom: 16px;
    }

    &__card {
      width: 100%;
      padding: 20px;
      background: #fff;
      box-shadow: 0 4px 10px rgba(43, 45, 52, 0.12);
      border-radius: 8px;

      &__title {
        margin-bottom: 12px;
        color: $ui-black-dark;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
      }

      ul {
        list-style-type: unset;
        list-style-position: inside;
        li {
          margin-bottom: 8px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
